<template>
  <v-container id="mais-info" fluid class="pt-12 pb-8 white"
    :class="{
      'px-12': $vuetify.breakpoint.mdAndUp,
      'px-8': $vuetify.breakpoint.smAndDown
    }"
  >
    <v-row class="text-center justify-center">
      <v-col cols="12" md="6">
        <h2 class="display-2 font-weight-medium pt-1">
          <span class="barlow black--text">GARANTA A SUA VAGA</span>
        </h2>
        <h3 class="title font-weight-regular pt-3">
          <span class="poppins grey--text text--darken-2">2 dias de treinamento intensivo para resgatar o seu puro ouro e <span class="font-weight-bold">transformar a sua vida!</span></span>
        </h3>
      </v-col>
    </v-row>
    <v-row
      class=""
      :class="{
        'px-12 mx-12 py-6': $vuetify.breakpoint.mdAndUp,
        'py-2': $vuetify.breakpoint.smAndDown
      }"
    >
      <v-col
        cols="12" md="6"
        :class="{
          'px-12': $vuetify.breakpoint.mdAndUp,
        }"
      >
        <v-card class="text-center">
          <v-card-title class="secondary d-block">
            <v-chip class="ma-2" color="primary">
              <v-icon left>mdi-fire</v-icon>
              <span class="font-weight-bold">DESCONTO 1º LOTE</span>
            </v-chip>
            <div class="body-2 text-uppercase font-weight-medium pt-5">
              <span class="white--text poppins">DE <span class="font-weight-bold" style="text-decoration: line-through">R$ 796</span> POR</span>
            </div>
            <div class="display-4 white--text">
              <span class="title font-weight-light">R$ </span><span class="font-weight-medium barlow">596</span>
            </div>
            <div class="body-2 font-weight-bold pt-2 pb-4">
              <span class="font-weight-regular white--text montserrat">ou 4x <span class="font-weight-black montserrat">R$ 149</span></span>
            </div>
          </v-card-title>
          <v-card-title class="text-center justify-center">
            <span class="font-weight-bold barlow">Treinamento Vivencial Luz e Sombra</span>
          </v-card-title>
          <div v-for="(i,j) in items" :key="j" class="py-0 my-0">
            <v-divider class="grey lighten-1"></v-divider>
            <v-card-title class="text-center justify-center">
              <span class="font-weight-medium barlow" v-html="i.titulo"></span>
            </v-card-title>
          </div>
          <v-divider class="grey lighten-1"></v-divider>
          <v-card-title class="text-center justify-center">
            <span class="font-weight-medium barlow">+ Desconto 1º Lote <v-icon color="primary">mdi-fire</v-icon></span>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col 
        cols="12" md="6"
        class="pb-12 justify-start text-left"
        :class="{
          'pr-12': $vuetify.breakpoint.mdAndUp,
          'pt-8': $vuetify.breakpoint.smAndDown
        }"
      >
        <hbt-contador :endtime="endtime" />
        <v-list
          disabled
          class="pt-8"
          color="transparent"
        >
          <v-list-item-group color="primary">
            <v-list-item 
              v-for="(l,i) in list" :key="i"
              class='px-0 mx-0'
            >
              <v-list-item-icon>
                <v-icon
                  :large="$vuetify.breakpoint.mdAndUp"
                  class="black--text"
                >
                  {{ l.icone }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  class="primary--text"
                  :class="{
                    'caption font-weight-regular': $vuetify.breakpoint.mdAndUp,
                    'subtitle-1': $vuetify.breakpoint.smAndDown,
                  }"
                >
                  <span>{{ l.rotulo }}</span>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <span class="headline font-weight-bold black--text">{{ l.titulo }}</span><br>
                  <span>{{ l.subtitulo }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-btn
          x-large
          color="primary white--text"
          class="mt-10 mx-auto title"
          :block="$vuetify.breakpoint.smAndDown"
          @click="dialog = true"
        >
          <span class="font-weight-bold">Quero me Inscrever<span v-if="$vuetify.breakpoint.mdAndUp"> Agora</span></span>
        </v-btn>
        <div class="caption pt-1 grey--text text--darken-2">
          É estudante universitário (qualquer curso) ou de formação em psicanálise? <a :href="whatsapp" target="_blank" class="primary--text text--lighten-1">Clique aqui</a> e peça seu cupom.
        </div>
      </v-col>

    </v-row>

    <v-dialog v-model="dialog"  max-width="600px">
<!--      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
      </template>-->
      <v-card class="pa-3">
        <v-card-title class="">
          <span class="headline pt-2">Pré-Inscrição</span>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.nome"
                  :rules="nomeRules"
                  label="Nome"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.sobrenome"
                  :rules="sobrenomeRules"
                  label="Sobrenome"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  type='email'
                  v-model="form.email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.whatsapp"
                  v-mask="mask"
                  label="WhatsApp"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  v-if="exibeCupom"
                  v-model="form.cupom"
                  :rules="cupomRules"
                  label="Cupom Promocional"
                  class="primary--text"
                  @keyup="capital"
                  required
                  :success="cupomValido"
                  :append-icon="cupomValido ? 'mdi-check' : ''"
                  
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="cupomValido">
                Parabéns, você ganhou um desconto adicional de R$ 200!
              </v-col>
              <v-col cols="12">
                <div
                  v-if="!exibeCupom"
                >
                  Tem um cupom promocional? <a @click="clicou">Clique aqui</a>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="pr-3">
          <v-spacer></v-spacer>
          <v-btn outlined color="grey darken-1 white--text" text @click="dialog = false" :disabled="loading">Fechar</v-btn>
          <v-btn id="submit" color="primary darken-1" 
            @click="submit" 
            :loading="loading" :disabled="loading"
          >Enviar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import HbtContador from '../components/Contador.vue'
import axios from 'axios'
//import swal from 'sweetalert'
import {mask} from 'vue-the-mask'

let qs = require('qs')

export default {
  directives: {mask},
  props:['endtime'],
  components: {
    HbtContador
  },
  data () {
    return {
      whatsapp: 'https://api.whatsapp.com/send?phone=5585997842054&text=Olá!%20Sou%20estudante%20de%20psicanálise%20e%20gostaria%20de%20pedir%20um%20cupom%20para%20o%20Treinamento%20Vivencial%20Luz%20e%20Sombra.',
      link: {
        'normal': '', // R$ 796
        'lote1': 'https://pag.ae/7VHKjXyw5', // R$ 596
        'alunos-lote1': 'https://pag.ae/7VHKndi4o', // R$ 396
      },
      exibeCupom: false,
      codigoCupom: 'SOULUZESOMBRA',
      dialog: false,
      loading: false,
      valid: false,
      mask: '(##) #####-####',
      form: {
        lista: 88,
        nome: '',
        sobrenome: '',
        email: '',
        whatsapp: '',
        indicador: null
      },
      nomeRules: [
        (v) => !!v || 'Informe seu nome'
      ],
      sobrenomeRules: [
        (v) => !!v || 'Informe seu sobrenome'
      ],
      emailRules: [
        (v) => !!v || 'Informe seu e-mail'
      ],
      cupomRules: [
        v => (!!v && v) === this.codigoCupom || 'Código inválido'
      ],
      items: [
        {
          titulo: '+ Coffee Break'
        },
        {
          titulo: '+ Certificado de Participação'
        },
      ],
      list: [
        {
          icone: 'mdi-calendar',
          rotulo: 'QUANDO',
          titulo: '21 e 22 de março',
          subtitulo: 'Sábado e Domingo'
        },
        {
          icone: 'mdi-map-marker',
          rotulo: 'ONDE',
          titulo: 'Instituto Alto Impacto',
          subtitulo: 'Av. Santos Dumont, 5554, Cocó, Fortaleza/CE'
        },
      ]
    }
  },
  computed: {
    cupomValido () {
      return this.form.cupom === this.codigoCupom
    }
  },
  methods: {
    capital() {
      this.form.cupom = this.form.cupom.toUpperCase()
    },
    clicou() {
      this.exibeCupom = true
    },
    getImg(i) {
      return require('../assets/img/'+i)
    },
    submit () {
      var vm = this
      vm.form.indicador = this.$route.params.indicador
      if (this.$refs.form.validate()) {
        console.log('validou')
        
        let params = qs.stringify({
          form: vm.form
//            form: $("#form_inscricao").serialize()
        })
////          let formData = $("#form_inscricao").serialize()
//          console.log(params)
        vm.loading = true //the loading begin
        axios.post('/leads/post2/', params)
          .then(response => {
            console.log('AXIOS NEXT', response.data)
            vm.loading = false
            if (response.status === 200) {
              // swal("Cadastro realizado com sucesso!", "Em breve entraremos em contato para efetivar sua inscrição.", "success", {
              //   button: "Fechar"
              // })
              vm.dialog = false
              
              // DISPARA EVENTO
              // gtag('event', 'obrigado', {
              //   'event_category': 'cadastro'
              // })
              // // DISPARA EVENTO GOOGLE
              // gtag('event', 'clique', {
              //   'event_category': 'enviar'
              // })
              window.gtag('event', 'conversion', { 
                'send_to': 'AW-665549619/fxt0CMb1psQBELP2rb0C', 
                'transaction_id': '' 
              })

              // DISPARA EVENTO FACEBOOK
              window.fbq('track', 'Lead')

              //vm.$router.push({ path: '/obrigado' })
              //window.open('https://pag.ae/7V542r7CJ')              
              
              console.log('evento disparado')

              if (this.cupomValido) {
                window.open(this.link['alunos-lote1'])
              }
              else {
                window.open(this.link['lote1'])
              }

            } else if (response.status === "error") {
              console.log("Log >>> Erro na gravação");
            }
          }).catch(e => {
            console.log('AXIOS CATCH', e)
            vm.loading = false
          })
      }
      else {
        console.log('não validou')
      }
    },
  }
}
</script>